<ion-header class="ion-no-border">
  <ion-toolbar mode="ios" color="none">
      <ion-title color="primary">
        {{'SYNC.TITLE'|translate}}
      </ion-title>
    <ion-button size="small" fill="clear" (click)="back()" slot="start">
      <ion-icon color="primary" name="chevron-back-outline"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <ion-grid>

    <div class="rounded white-bg ion-text-center">

      <p *ngIf="newDevices.length <= 0 && siteDevices.length <= 0">Aucune serrure détectée.</p>

        <ion-list class="rounded">
          <ion-list-header class="ion-align-items-center">
            <ion-label class="ion-align-items-center">
              <h2>{{'SYNC.SUBTITLE'|translate}}&nbsp; <ion-spinner color="primary" size="small" name="crescent" *ngIf="searching"></ion-spinner></h2>
            </ion-label>
              <ion-button (click)="presentHelpModal()" size="small" fill="clear">
                <ion-icon size="small" name="help-circle-outline" slot="icon-only" color="primary"></ion-icon>
              </ion-button>
          </ion-list-header>          

          <ion-item *ngFor="let newDevice of newDevices" lines="full" button (click)="install(newDevice)">
            <!-- <ion-label slot="start" class="icons-label ion-text-start">
              <div>
                <ion-icon color="secondary" name="bluetooth" title="compatible bluetooth" size="small"></ion-icon>
                <ion-icon *ngIf="device.properties.lorawan" title="compatible LORA" color="success" name="logo-rss"
                  size="small">
                </ion-icon>
              </div>
              <h4>
              </h4>
            </ion-label> -->
            <!-- <ion-avatar slot="start"> -->
              <ion-icon class="icon-cylindre" size="large" src="assets/Contour-Cylindres.svg"></ion-icon>
            <!-- </ion-avatar> -->
            <ion-button class="signal-icon" fill="clear">
                <img color="primary" style="max-width: 16px;" [src]="'../../../assets/icon/'+ newDevice.signalIcon" alt="">
            </ion-button>
            <ion-label class="ion-text-start">
              <!-- <h3>
                {{ device.properties.name | titlecase}}
              </h3> -->
              <div *ngIf="newDevice.syncProgress; else newDevice_not_sync">
                <p>
                  {{newDevice.status | translate}}
                </p>
                <p>
                  <ion-progress-bar [value]="newDevice.syncProgress"></ion-progress-bar>
                </p>
              </div>
              <ng-template #newDevice_not_sync>
                <p>
                  {{ newDevice.serial}}
                </p>
                <!-- <p>
                  <img style="max-width: 32px;" [src]="'../../../assets/icon/'+ newDevice.signalIcon" alt="">
                </p> -->
              </ng-template>
            </ion-label>

            <!-- <ion-item-group *ngIf="!device.isConnected" class="ion-text-right ion-no-padding"> -->
            <!--If device has pending tasks, user has sufficient rights and device is not syncing or in error, display sync button-->
            <ion-item-group class="ion-text-right ion-no-padding">
              <ion-button class="buttons" fill="clear" slot="end"
                (click)="install(newDevice);$event.stopPropagation();">
                <!-- <ion-icon *ngIf="!device.tasksCount" slot="icon-only" name="settings" size="large"></ion-icon> -->
                <!-- <i name="add-circle-outline" class="fas fa-sync-alt"></i> -->
                <ion-icon slot="icon-only"  name="add-circle-outline"></ion-icon>
                <!-- <i class="fa-regular fa-wrench"></i> -->
                <!-- Installer -->
                <!-- {{'DEVICE.ASSIGNMENT.ASSIGNMENTBTNSHORT'|translate}} -->
              </ion-button>
            </ion-item-group>
          </ion-item>


          <ion-item  *ngFor="let device of devices" lines="full" button (click)="viewDetail(device)">
            <!-- <ion-label slot="start" class="icons-label ion-text-start">
              <div>
                <ion-icon color="secondary" name="bluetooth" title="compatible bluetooth" size="small"></ion-icon>
                <ion-icon *ngIf="device.properties.lorawan" title="compatible LORA" color="success" name="logo-rss"
                  size="small">
                </ion-icon>
              </div>
              <h4>
              </h4>
            </ion-label> -->
            <!-- <ion-avatar slot="start"> -->
              <ion-icon class="icon-cylindre" size="large"  src="assets/Contour-Cylindres.svg"></ion-icon>              
            <!-- </ion-avatar> -->
            <ion-button fill="clear"  class="signal-icon" >
              <img color="primary" style="max-width: 16px;" [src]="'../../../assets/icon/'+ device.signalIcon" alt="">
            </ion-button>
            <ion-label class="ion-text-start">
              <!-- <h3 *ngIf="userInfo && isSuperAdmin()">
                {{ device.properties.name | titlecase}} ({{device.id}})
              </h3>
              <h3 *ngIf="!userInfo || !isSuperAdmin()"> -->
              <h3 *ngIf="device.properties.name.length">
                {{ device.properties.name | titlecase}}
              </h3>
              <h3 *ngIf="!device.properties.name.length">
                {{ device.serialNumber | titlecase}}
              </h3>
              <!-- <div *ngIf="!device.isConnected && device.syncEnd === true">
                <p>
                  {{'SYNC.END'|translate}}
                </p>
                <p>
                  <ion-progress-bar value="1"></ion-progress-bar>
                </p>
              </div>
              <div *ngIf="device.isConnected && device.syncEnd === false; else device_not_sync">
                <p>
                  {{'SYNC.PROGRESS'|translate}}
                </p>
                <p>
                  <ion-progress-bar type="indeterminate"></ion-progress-bar>
                </p>
              </div> -->
              <div *ngIf="device.syncProgress; else device_not_sync">
                <p>
                  {{device.status | translate}}
                </p>
                <p>
                  <ion-progress-bar [value]="device.syncProgress"></ion-progress-bar>
                </p>
              </div>
              <ng-template #device_not_sync>                
                  <!-- <ion-icon *ngIf="device.properties.lowBattery" class="battery-clignote"  slot="icon-only" name="battery-dead" mode="ios" size="small" color="danger"></ion-icon>             -->
              </ng-template>
            </ion-label>
            <!-- <ion-label *ngIf="!device.isConnected" class="ion-text-start">
              <h3>
                {{ device.properties.name | titlecase}}
              </h3>
              <p>
                {{ device.serialNumber}}
              </p>
              <p>
                <img style="max-width: 32px;" [src]="'../../../assets/icon/'+ device.signalIcon" alt="">
              </p>
            </ion-label> -->

            <!-- <ion-item-group *ngIf="!device.isConnected" class="ion-text-right ion-no-padding"> -->
            <!--If device has pending tasks, user has sufficient rights and device is not syncing or in error, display sync button-->
            <ion-item-group>
              <!-- <ion-button *ngIf="device.properties.lowBattery" size="small" fill="clear" slot="end">
                <ion-icon  class="battery-clignote" slot="icon-only" name="battery-dead" mode="ios"  color="danger"></ion-icon> 
              </ion-button> -->
              <ng-container *ngIf="device.properties.battery && displayBattery">
                <ion-button *ngIf="device.properties.battery > 60" size="small" fill="clear" slot="end">
                  <ion-icon slot="icon-only" name="battery-full-outline" size="large">
                  </ion-icon>
                </ion-button>
                <ion-button *ngIf="device.properties.battery <= 60 && device.properties.battery > 20" size="small" fill="clear" slot="end">
                  <ion-icon slot="icon-only" name="battery-half-outline" size="large">
                  </ion-icon>
                </ion-button>
                <ion-button *ngIf="device.properties.battery <= 20" size="small" fill="clear" slot="end">
                  <ion-icon slot="icon-only" class="battery-clignote" *ngIf="device.properties.battery <= 20" name="battery-dead-outline"
                  size="large"></ion-icon>
                </ion-button>
              </ng-container>
              <ion-button  size="small" *ngIf="shouldDisplaySyncButton(device)" fill="clear" slot="end"
                (click)="forceSync(device);$event.stopPropagation();">
                <!-- <ion-icon *ngIf="!device.tasksCount" slot="icon-only" name="settings" size="large"></ion-icon> -->
                <ion-icon  color="primary" name="sync-outline"></ion-icon>
              </ion-button>

              <ion-button size="small" fill="clear" slot="end" (click)="open(device);$event.stopPropagation();">
                <ion-icon slot="icon-only" name="lock-closed-outline" ></ion-icon>
              </ion-button>
              <ion-button *ngIf="upgradeAvailable(device)" class="buttons" fill="clear" slot="end" (click)="update(device);$event.stopPropagation();">
                <ion-icon slot="icon-only" name="download" size="large"></ion-icon>
              </ion-button>
            </ion-item-group>
          </ion-item>
        </ion-list>



      <div style="text-align: center;">
        <ion-button color="primary" (click)="refresh()">
          Relancer le scan
        </ion-button>
        <!-- <ion-button *ngIf="!syncing && (!autoSync || syncError)" (click)="enableAutoSyncOnce()"> -->
        <ion-button *ngIf="(!syncing && !autoSync)" (click)="enableAutoSyncOnce()">
          {{ 'SYNC.ENABLE' | translate}}
        </ion-button>
      </div>

      <!-- <hr>
      <ion-toolbar color="none">
        <ion-row class="ion-align-items-center">
          <ion-col class="ion-text-center">
            <ion-badge>{{ this.siteDevices.length }}</ion-badge>&nbsp; serrures sur vos parcs
          </ion-col>
        </ion-row>
      </ion-toolbar> -->

      <!-- <span *ngIf="userInfo != null">
        <div *ngIf="userInfo.email === 'unittest6@loopback.io'
        || userInfo.email === 'fmrichiardi@groupe-inoveo.fr'
        || userInfo.email === 'ngrange@u-link.fr'
        || userInfo.email === 'jturello@u-link.fr'
        || userInfo.email === 'apalermo@u-link.fr'
        || userInfo.email === 'fm@fm.fr'
        || userInfo.email === 'ngrange@groupe-inoveo.fr'
        || userInfo.email === 'amaury@yruama.fr'" class="ion-hide-lg-up">

          <ion-button class="ion-hide-lg-up" fill="clear" (click)="clearCache()">
            <ion-icon src="assets/>Orange.svg"></ion-icon>
            &nbsp;&nbsp;
            <ion-label>Vider cache</ion-label>
          </ion-button>

        </div>
      </span> -->
    </div>
  </ion-grid>

</ion-content>
